/* import __COLOCATED_TEMPLATE__ from './conversations-cell.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';

interface Args {
  contentWrapper: ContentWrapper;
}

export default class ConversationsCell extends Component<Args> {
  get conversations() {
    return (
      new Set(this.args.contentWrapper.contentReviewSuggestionMetadata?.included_conversations)
        .size || undefined
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::List::Cells::ConversationsCell': typeof ConversationsCell;
  }
}
